import './InstructionDetails.scss';
import InstructionDetails from './InstructionDetails';
import { getAreaComponents } from '@/utilities/functions/magnoliaUtils';
import { IInstructionListItem, ILinkInterface } from './interfaces';

function InstructionDetailAdapter(props: any) {
  const mgnlInstructionListItems = props.instructionListItems ? getAreaComponents(props.instructionListItems) : [];
  const instructionListItems: IInstructionListItem[] = mgnlInstructionListItems.map((item: any, itemIndex: number) => {

    const mgnlGuidelines = item.guidelines ? getAreaComponents(item.guidelines) : [];
    const guidelines: string[] = mgnlGuidelines.length ? mgnlGuidelines.map((guideline: any) => guideline.text) : [];

    const mgnlLinks = item.links ? getAreaComponents(item.links) : [];
    const mgnlFiles = item?.fileDownload?.['@nodes'].length ? getAreaComponents(item.fileDownload) : [];
    const links: ILinkInterface[] = mgnlLinks.length ? mgnlLinks.map((link: any, linkIndex: number) => {
      return {
        id: `instruction-list-item-${itemIndex}-link-${linkIndex}`,
        label: link.label,
        redirectUrl: link.redirectUrl,
        isOpenNewTab: link.isOpenNewTab
      }
    }) : [];

    return {
      id: `instruction-list-item-${itemIndex}`,
      title: item.title,
      text: item.text,
      guidelines: guidelines,
      links: links,
      fileDownload: mgnlFiles
    };
  })

  return (
    <InstructionDetails
      contentSectionHeader={props.contentSectionHeader}
      instructionListItems={instructionListItems}
      inlineHeadline={props.inlineHeadline}
      inlineAlertText={props.inlineAlertText}
      contentSectionDescription={props.contentSectionShortDesc}
    />
  );
}

export default InstructionDetailAdapter;
